import { render, staticRenderFns } from "./TruckUpload.vue?vue&type=template&id=9ab77682&scoped=true"
import script from "./TruckUpload.vue?vue&type=script&lang=js"
export * from "./TruckUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab77682",
  null
  
)

export default component.exports